/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { accessibleEntityColorsWithWhiteBackground } from 'src/core/themes/themeBuilder';
import { numberToPercentageString } from 'src/core/utils/number';
import { commonDemosMessages } from 'src/languageStudio/appShell/prebuiltDemos/utils/commonDemoMessages';
import { questionCardStyle, resultCardTitleStyles } from 'src/languageStudio/appShell/prebuiltDemos/utils/commonStyles';

export type QuestionCardProps = {
    question: string;
    confidenceScore: number;
    questionIndex: number;
};

const messages = defineMessages({
    question: { id: 'languageStudio.QuestionCard.question', defaultMessage: 'Question {questionNumber}' }
});

export const QuestionCard = (props: QuestionCardProps) => {
    const { question, confidenceScore, questionIndex } = props;

    const { localize } = useLocalization();

    return (
        <Stack tokens={{ childrenGap: 7 }} styles={questionCardStyle}>
            <LuisText fontWeight={400} styles={resultCardTitleStyles(accessibleEntityColorsWithWhiteBackground[questionIndex])}>
                {localize(messages.question, { questionNumber: questionIndex + 1 })}
            </LuisText>
            <Stack>
                <LuisText fontWeight={600} shouldWrapText variant="smallPlus">
                    {question}
                </LuisText>
                <br />

                <LuisText variant="smallPlus">
                    <span style={{ fontWeight: 400 }}>{localize(commonDemosMessages.confidenceLabel)}</span>&nbsp;
                    {numberToPercentageString({ ratio: confidenceScore })}
                </LuisText>
            </Stack>
        </Stack>
    );
};
